import Header from "./components/Header";
import Display from './components/DisplayView'
import SearchBar from './components/SearchBar'
import PlayerCard from './components/PlayerCard'
import Footer from './components/Footer'
import { useState } from "react";
import OutsideClickHandler from 'react-outside-click-handler'

const App =()=> {


  //change player based off of current playered clicked
  const [player, setPlayer] = useState({})
  const [open, setOpen] = useState(false)
  
  const setOpened =(newOpen)=>{
    //console.log(newOpen)
    document.body.style.overflow = 'hidden'
    setOpen(newOpen)
  }
  
  //returns opened = false and closes card
  const setClosed =(close)=> {
    document.body.style.overflow = 'unset'
    setOpen(close)
  }
  const setNewPlayer =(newPlayer)=>{
    setPlayer(newPlayer)
  }

  return (

    <div>

      {
        open && <div className="playerCard-container">
          <OutsideClickHandler onOutsideClick={()=>setClosed(false)}>
            <PlayerCard newPlayer={player} setClosed={setClosed}/>
          </OutsideClickHandler>
        </div>
      }
      <Header title="All Star List"/>
      <SearchBar setOpened={setOpened} setNewPlayer={setNewPlayer} />
      <Display setOpened={setOpened} setNewPlayer={setNewPlayer}/>
      <Footer />
      
    </div>
    
  )
}

export default App;
